import { useStandardProductContext } from "app/providers/StandardProductProvider";
import MainProductSceneCarousel from "entities/configurator/product-scene-carousel";
import StandardProductSceneCarousel from "entities/configurator/standard-product-scene-carousel";
import { Suspense } from "react";
import { concatClassnames } from "shared/utils/concatClassnames";

// const ProductSceneCarousel = lazy(
// 	() => import("../../../entities/configurator/product-scene-carousel/index")
// );

// const StandardProductSceneCarousel = lazy(
// 	() => import("entities/configurator/standard-product-scene-carousel")
// );
interface ConfigurationProductProps {
  className?: string;
}
const ConfiguratorProduct = ({ className }: ConfigurationProductProps) => {
  const { showStandardProducts } = useStandardProductContext();

  return (
    <section
      className={concatClassnames(
        "gg-relative lg:gg-sticky lg:gg-top-[150px] lg:gg-z-10",
        className,
      )}
    >
      {showStandardProducts ? (
        // Render StandardProductSceneCarousel if standard products need to be shown
        <>
          <Suspense fallback={null}>
            <StandardProductSceneCarousel className="gg-col-span-12" />
          </Suspense>
        </>
      ) : (
        // Render ProductSceneCarousel if door products need to be shown
        <>
          <Suspense fallback={null}>
            <MainProductSceneCarousel className="gg-col-span-12" />
          </Suspense>
        </>
      )}
    </section>
  );
};
export default ConfiguratorProduct;
